import { Purl } from "@sscs/types";
import { parsePurl } from "@sscs/utils";

export const decomposePurl = (purl: string): Purl | null => {
  try {
    const purlComponents = parsePurl(purl);

    return {
      ...purlComponents,
    };
  } catch {
    return null;
  }
};

const DOCKER_HARDENED_IMAGES_HOST = "dhi.io";

export const requiresDockerHubCredentials = (purl: string): boolean => {
  const purlComponents = decomposePurl(purl);

  if (purlComponents?.type !== "docker") return false;

  const repositoryUrl = purlComponents.qualifiers?.repository_url;

  return !repositoryUrl || repositoryUrl === DOCKER_HARDENED_IMAGES_HOST;
};
